export class AvailabilitiesFetchedError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'AvailabilitiesFetchedError'
    Object.setPrototypeOf(this, AvailabilitiesFetchedError.prototype)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AvailabilitiesFetchedError)
    }
  }
}
